import { NetworkWizardDispatcher } from "./Variable";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../react-core/Flux/BaseStore";

export interface NetworkWizardStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class NetworkWizardStoreStatic extends BaseStore<NetworkWizardStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(NetworkWizardDispatcher, (actionData) => this.onNetworkStoreResponse(actionData));
    }

    public getLastResult(): NetworkWizardStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): NetworkWizardStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onNetworkStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
